import { render, staticRenderFns } from "./PageHome.vue?vue&type=template&id=80cabd2c&scoped=true&"
import script from "./PageHome.vue?vue&type=script&lang=js&"
export * from "./PageHome.vue?vue&type=script&lang=js&"
import style0 from "./PageHome.vue?vue&type=style&index=0&id=80cabd2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cabd2c",
  null
  
)

export default component.exports